import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppGameDetailsSelector, useAppTvImageSelector } from "src/_common/hooks/selectors/eventSelector";
import {
  APPLICATION_GLOBAL_SLUG,
  removeEmptyObjectKey,
  removeTrailingZero,
  SOCKET_CHANNEL,
  SOCKET_URL,
} from "src/_config";
import useSocket from "use-socket.io-client";

interface RPRodeoGroupTvImageProps {
  // globalTvData: any;
  // socketChannel: any;
  // setGlobalTvData: Function;
  // setSocketChannel: Function;
}

export function RodeoGroupTvImageComponent({}: // globalTvData,
// socketChannel,
// setGlobalTvData,
// setSocketChannel,
RPRodeoGroupTvImageProps) {
  const eventApi = useEventApi();
  // const tvImageSelector = useAppTvImageSelector()
  const { groupId } = useParams<any>();
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const gameDetails = useAppGameDetailsSelector();
  const [tvLeaderboardList, setTvLeaderboardList] = useState<any>();
  const [randomDrawNo, setRandomDrawNo] = useState<any>("");
  const [tvImageSelector, setTvImageSelector] = useState<any>();
  const [leaderboardType, setLeaderboardType] = useState<any>(0);
  const history = useHistory();

  const getTvImageDetails = (screen1: string) => {
    const params = {
      screen1,
    };
    eventApi.callGroupTvImageDetails(
      params,
      (message: string, resp: any) => {
        console.log({ resp });
        if (resp) {
          setTvImageSelector(resp);
          if (resp?.rodeo_event_game_info?.length > 0) {
            let x = resp?.rodeo_event_game_info[0].show_leaderboard;
            console.log(">>>>>>>leaderboard", x, resp);
            if (x) {
              setLeaderboardType(x);
              if (x == 1) {
                let p = resp?.players;
                p.map((item: any) => {
                  // item["value_to_show"] = (item?.total_win || 0) + "/" + resp?.events_count;
                  item["value_to_show"] = item?.total_win || 0;
                });
                setTvLeaderboardList(p);
                setRandomDrawNo(resp?.players[0]?.per_tie_total || "");
              } else if (x == 2) {
                let r = resp?.riders;
                r.map((item: any) => {
                  item["avatar"] =
                    item?.rider?.id != 0
                      ? item?.rider?.original
                      : item?.contestant_dtls?.avatar?.id != 0
                      ? item?.contestant_dtls?.avatar?.original
                      : "/images/no-image.png";
                  item["value_to_show"] = removeTrailingZero(item?.vote) + " %";
                });
                setTvLeaderboardList(r);
                setRandomDrawNo("");
              } else {
                let e = resp?.events;
                e.map((item: any) => {
                  item["avatar"] =
                    item?.truck?.event_truck?.id != 0
                      ? item?.truck?.event_truck?.original
                      : item?.truck?.rodeo_pick_event?.avatar?.id != 0
                      ? item?.truck?.rodeo_pick_event?.avatar?.original
                      : "/images/no-image.png";
                  item["value_to_show"] = item?.total_win || 0;
                });
                setTvLeaderboardList(e);
                setRandomDrawNo("");
              }
            }
          }
          setIsInitialLoad(false);
        }
      },
      (message: string) => {
        setIsInitialLoad(true);
        resetCssStyle("landing");
        console.error(`Error at API Access => ${message}`);
      }
    );
    // }
  };

  const getGameDetails = () => {
    let params = {
      slug: APPLICATION_GLOBAL_SLUG,
    };
    eventApi.callGetGameDetails(
      params,
      (message: any, resp: any) => {
        // console.log({resp})
        // setIsInitialLoad(false);
      },
      (message: any) => {}
    );
  };

  const resetCssStyle = (type: any) => {
    var element = document.getElementById("rodeo_body");
    if (element && isInitialLoad) {
      if (["leaderboard", "ad"].includes(type)) {
        element.style.padding = "0 30px";
        element.style.paddingTop = "2.5em";
      } else {
        element.style.padding = "0px";
      }
    }
  };

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
  });

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.GROUP_TV_BOARD_IMAGE, (data: any) => {
      history.push(`/group-tv-leaderboard/${data.enc_group_id}`);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   if (globalTvData && socketChannel) {
  //     resetCssStyle("ad");

  //     switch (socketChannel) {
  //       case SOCKET_CHANNEL.GROUP_TV_BOARD_IMAGE:
  //         getTvImageDetails(groupId);
  //         break;
  //     }
  //     setGlobalTvData(null);
  //     setSocketChannel(null);
  //   }
  // }, [globalTvData, socketChannel]);

  useEffect(() => {
    setRandomDrawNo("");
    getTvImageDetails(groupId);
    getGameDetails();
    // var element = document.getElementById("rodeo_body");
    // if (element) {
    //   element.style.paddingTop = "0px";
    //   element.style.marginBottom = "0px";
    //   element.style.backgroundColor = "#fff";
    //   // element.style.backgroundImage = 'none'
    // }
    resetCssStyle("ad");
  }, [groupId]);

  return (
    <React.Fragment>
      {isInitialLoad ? (
        <div
          className="main-bg"
          style={{
            backgroundImage: `url("${"/images/tv/tv-screen-blank1.jpg"}")`,
            position: "fixed",
            width: "100%",
            height: "100%",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
      ) : (
        <>
          <div
            className="main-bg"
            style={{
              backgroundColor: "#000",
              position: "fixed",
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
              zIndex: -1,
              overflowX: "hidden",
              margin: 0,
            }}
          ></div>
          <section className="container" style={{ maxWidth: "100%" }}>
            <div className="logobar ">
              <div className="border-div" />
              <div className="border-div2" />
              <div className="logo_left_txt">
                {tvImageSelector && tvImageSelector.group_details ? tvImageSelector.group_details.title : "--"}
              </div>
              <div className="logo_image">
                <img src={gameDetails?.logo?.original} className="img-responsive" />
              </div>
            </div>

            {/* <div className={"heading_text " + (randomDrawNo ? "my-3" : "")}> */}
            <div className={"heading_text " + (tvImageSelector?.group_details?.sub_heading ? "my-3" : "")}>
              {/* {tvImageSelector && tvImageSelector.event_dtls && tvImageSelector.event_dtls.sponsor
                ? `SPONSORED BY ${tvImageSelector.event_dtls.sponsor.title}`
                : null} */}
              {/* {randomDrawNo ? ( */}
              {tvImageSelector?.group_details?.sub_heading ? (
                <div className="text-center text-white" style={{ fontSize: "20px" }}>
                  {/* RANDOM DRAW NUMBER (to be used for tie breaker): {randomDrawNo} */}
                  {tvImageSelector?.group_details?.sub_heading}
                </div>
              ) : null}
            </div>
            <div className="clearfix">
              <ul className="tv-list">
                {tvLeaderboardList?.length ? (
                  tvLeaderboardList
                    ?.slice(0, tvImageSelector && tvImageSelector.limit ? tvImageSelector.limit : 10)
                    .map((item: any, i: any) => (
                      <li key={i}>
                        <div className="left_sec">
                          <div className="border-div"></div>
                          <div className="curve-bg">
                            <div className="left_sec_l">
                              {item.avatar ? (
                                <span className="event-img tv-avatar">
                                  <img src={item.avatar} />
                                </span>
                              ) : null}
                              <div>
                                {leaderboardType == 2
                                  ? item?.name
                                  : leaderboardType == 1
                                  ? item?.user_details?.display_name || item?.user_details?.full_name
                                  : leaderboardType == 3
                                  ? item?.event_name || item?.details?.rodeo_pick_event?.title
                                  : ""}
                              </div>
                            </div>
                            {/* <div className="left_sec_r">{removeTrailingZero(item.vote)} %</div> */}
                            {/* <div className={"left_sec_r " + (item.user_tie_total ? "lucky" : "")}> */}
                            <div className={"left_sec_r"}>{item.value_to_show}</div>
                            {/* {item?.user_tie_total ? (
                              <div className="left_sec_r left_sec_r_code">
                                {"(" +
                                  (item?.user_tie_total == 99999 || item?.user_tie_total == 9999999
                                    ? "-"
                                    : item?.user_tie_total || "-") +
                                  ")"}
                              </div>
                            ) : null} */}
                          </div>
                        </div>
                      </li>
                    ))
                ) : (
                  <div className="text-center" style={{ color: "#fff" }}>
                    <p> No Results published yet!</p>
                  </div>
                )}
              </ul>
            </div>
          </section>
        </>
      )}
    </React.Fragment>
  );
}
